import "./Login.css";
import "./ForgetPassword.css";
import email_icon from "../../Assets/email.png";
import { useState } from "react";
import { ResponseMessage } from "../../models/ResponseMessage";
import { resetPasswordRequestAsync } from "../../api/AccountApi";

const ForgetPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleForgetPassword = async () => {
    if (!email) {
      alert("Please provide the email address");
      return;
    }
    setLoading(true);
    try {
      const response: ResponseMessage<boolean> =
        await resetPasswordRequestAsync(email);

      if (response.success) {
        setLoading(false);
        alert("password request link sent to your register email addrress");
      } else {
        setLoading(false);
        alert("No user found on this email address");
      }
    } catch (error) {
      setLoading(false);
      //console.error("❌ Registration failed:", error);
      alert("password request failed. Please try again.");
    }
  };

  return (
    <div className="container">
      <div className="holder_forgetpassword">
        <label>Password Reset</label>
        {loading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
          </div>
        )}
        <div className="input-wrapper">
          <img className="input-icon" src={email_icon} alt="email icon" />
          <input
            className="input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button className="forget-password-btn" onClick={handleForgetPassword}>
          Request Password Reset
        </button>
      </div>
    </div>
  );
};

export default ForgetPassword;
